<template>
  <div
    class="markdown"
    v-html="text"/>
</template>

<script>
// import marked from 'marked'
import changelog from '@/../changelog.md'
// const debug = require('debug')('OD::ChangeLog')

export default {
  name: 'ChangeLog',
  components: {},
  props: {},
  data() {
    return {}
  },
  computed: {
    text() {
      return changelog
    },
  },
  watch: {},
  created() {},
  methods: {},
}
</script>
<style lang="scss">

</style>
